import { defaultDomain } from './default-domain';

// The server returns image / asset URLs as server-relative paths (e.g.
// "/api/shop/foo/assets/menu/images/abc?v=12345"). For <img src> tags those
// have to be absolute, since the PWA may be on a different origin to the
// API. resolveAssetUrl prepends the API base URL when needed and leaves
// already-absolute URLs alone (in case the server ever hands back an
// absolute SAS URL again, this stays compatible).
export function resolveAssetUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  const base = defaultDomain ?? window.location.origin;
  if (url.startsWith('/')) return `${base}${url}`;
  return `${base}/${url}`;
}
